import { getGoldCot } from "@/lib/cot.functions"
import { getUsCpi } from "@/lib/cpi.functions"
import { getUsEmployment } from "@/lib/nfp.functions"
import { getGoldSeasonality } from "@/lib/seasonality.functions"
import { getGoldRetailSentiment } from "@/lib/retail-sentiment.functions"
import { getDeskIntel } from "@/lib/desk-intel.functions"
import { getTerminalCandles } from "@/lib/terminal-candles.functions"
import { getGoldOptions } from "@/lib/gold-options.functions"
import { getMacroSurprises } from "@/lib/macro-surprise.functions"
import { getRealYield } from "@/lib/real-yield.functions"
import { classifyStructure } from "@/lib/desk-intel.functions"

const safe = <T,>(p: Promise<T>) => p.catch(() => null)
export async function loadMacroLensInputs() {
  const [cot, cpi, nfp, season, retail, intel, d1, options, surprises, realYield, w1] = await Promise.all([
    safe(getGoldCot()), safe(getUsCpi()), safe(getUsEmployment()), safe(getGoldSeasonality()),
    safe(getGoldRetailSentiment()), safe(getDeskIntel()), safe(getTerminalCandles({ data: { tf: "D1" } })),
    safe(getGoldOptions()), safe(getMacroSurprises()), safe(getRealYield()), safe(getTerminalCandles({ data: { tf: "W1" } })),
  ])
  // Only the latest reading is needed for scoring; drop the heavy history.
  const ry = realYield?.latest ? { latest: realYield.latest, stale: realYield.stale ?? false } : null
  return { cot, cpi, nfp, season, retail, intel, d1: d1?.candles.slice(-20) ?? [], options, surprises, realYield: ry, w1Label: w1?.candles.length ? classifyStructure(w1.candles, 1).label : null }
}
